import { t } from 'ttag'
import { useContext, useState } from 'react'

import { Link } from '@h2/common/components/link'
import { Grid } from '@h2/components/containers/grid'
import { Text } from '@h2/components/typography/text'
import { Button } from '@h2/components/buttons/button'
import { AddIcon } from '@h2/components/icons'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { Globals } from '@h2/globals'

import { CreateGroup } from './components/createGroup'

import { ActionsRow } from '../commonComponents/actionsRow'

const GroupListing = ({ results }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { userProfile } = useContext(Globals)
  const columns = [
    {
      id: 'name',
      label: t`Name`
    },
    {
      id: 'dateCreated',
      label: t`Date Created`,
      width: '150px',
      render({ created }) {
        return new Date(created).toLocaleDateString()
      }
    },
    {
      id: 'id',
      label: t`Action`,
      width: '95px',
      sortable: false,
      render({ id }) {
        return (
          <Link href={`/management/groups/${id}`} variant="outlined" isFullWidth={true}>
            {t`View`}
          </Link>
        )
      }
    }
  ]
  const innerContent = () => {
    if (!results?.length) {
      return (
        <Text margin="60px" size="large" align="center">
          {t`There are no groups available.`}
        </Text>
      )
    }

    return (
      <Grid
        data={results}
        columns={columns}
        options={{ disableFilters: true }}
        rowIdKey="id"
        defaultPageSize={50}
        isRowSelectable={false}
        dateRangePicker={true}
      />
    )
  }
  const closeModal = () => {
    setIsOpen(false)
  }
  const openModal = () => {
    setIsOpen(true)
  }

  return (
    <div>
      {userProfile.hasSchoolAdmin && (
        <ActionsRow>
          <ActionsRow.Actions>
            <Button icon={AddIcon} variant="outlined" align="right" onClick={openModal}>
              {t`Create Group`}
            </Button>
          </ActionsRow.Actions>
        </ActionsRow>
      )}
      {innerContent()}
      <Modal isOpen={isOpen} closeOnClickOverlay={true} onClose={closeModal}>
        <Modal.Header>
          <Heading level="3">{t`Create a Group`}</Heading>
        </Modal.Header>
        <Modal.Body>
          <CreateGroup onCreate={closeModal} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export { GroupListing }
